import React, { useContext, useEffect, useState } from "react";
import { PaginatedLandingContent } from '../components/paginated-landing-content-app';
import { IPaginatedLandingContent } from '../models/paginated-landing-content'
import { IPage } from '../../global/state-helpers/page';
import * as queryString from 'query-string';
import PageContext from '../context/pageContext';



export default function App() {
    const paginatedElements = (window as any).bootstrap.PaginatedElements as IPaginatedLandingContent[];
    const paginatedFilters = (window as any).bootstrap.Filters;
    const pageSize = (window as any).bootstrap.PageSize;
    const rawParams = queryString.parse(window.location.search, { parseNumbers: true })
    let pageModel = { page: rawParams.page ? +rawParams.page : 1, pageSize: pageSize } as IPage;
    let searchText = rawParams.q && rawParams.q.toString();
    const [topicFilter, setTopicFilter] = useState([]);
    const [roleFilter, setRoleFilter] = useState([]);
    const [ageFilter, setAgeFilter] = useState([]);
    const [activeFilter, setActiveFilter] = useState(false);
    const [filtersData, setFiltersData] = useState(paginatedFilters);

    const updateTopicFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.TopicFilters
        filterChanged[filterIndex].Value = newCount;
        setFiltersData({ ...filtersData, TopicFilters: [...filterChanged] });
    }

    const updateRoleFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.RoleFilters
        filterChanged[filterIndex].Value = newCount;
        setFiltersData({ ...filtersData, RoleFilters: [ ...filterChanged ] });
    }
    const updateAgeFilterCount = (filterIndex: number, newCount: number) => {
        let filterChanged = filtersData.AgeRangesFilters
        filterChanged[filterIndex].Value = newCount;
        setFiltersData({ ...filtersData, AgeRangesFilters: [...filterChanged] });
    }
return (
    <PageContext.Provider value={{
        topicFilter: topicFilter,
        setTopicFilter: setTopicFilter,
        roleFilter: roleFilter,
        ageFilter: ageFilter,
        setAgeFilter: setAgeFilter,
        setRoleFilter: setRoleFilter,
        activeFilter: activeFilter,
        setActiveFilter: setActiveFilter,
    }}>

        <PaginatedLandingContent
            items={paginatedElements}
            pageModel={pageModel}
            searchText={searchText}
            filtersData={filtersData}
            topicFilter={topicFilter}
            roleFilter={roleFilter}
            ageFilter={ageFilter}
            activeFilter={activeFilter}
            updateTopicFilterCount={updateTopicFilterCount}
            updateRoleFilterCount={updateRoleFilterCount}
            updateAgeFilterCount={updateAgeFilterCount}
        />
    </PageContext.Provider>
);
}


